<template>
  <div class="privacy">
    <header-top :headerPosition="false">
      <div slot="title">{{ appName }}隐私政策</div>
    </header-top>

    <div class="privacy-wrapper">
      <div class="privacy-date">发布日期：2024年09月04日</div>
      <div class="privacy-date privacy-date-second">
        生效日期：2024年09月04日
      </div>
      <p><span style="font-weight:bold">提示条款</span></p>
      <p style="text-indent:21pt">
        <span
          >“{{ appName }}”的运营主体成都陌陌科技有限公司（以下简称“我们”）深知个人信息对您的重要性，并会尽力保护您的个人信息安全可靠，我们致力于维持您对我们的信任，恪守以下原则，保护您的个人信息：权责一致原则，目的明确原则，选择同意原则，最少够用原则，确保安全原则，主体参与原则，公开透明原则等。同时我们承诺，我们将按业界成熟的安全解决方案，采取相应的安全保护措施来保护您的个人信息。鉴此，我们制定本《隐私政策》（下称“本政策
          /本隐私政策”）并提醒您：</span
        >
      </p>
      <p style="text-indent:21pt"><span>本政策适用于“{{ appName }}”软件及相关服务。</span></p>
      <p style="text-indent:21pt">
        <span style="font-weight:bold; text-decoration:underline"
          >在使用“{{ appName }}”软件及相关服务前，请您务必仔细阅读并理解本政策，在确认充分理解并同意后使用相关产品或服务。您同意隐私政策仅代表您已了解我们提供的产品或服务的基本功能，以及功能运行所需的必要个人信息，并不代表您已单独同意我们可以收集非必要个人信息。非必要个人信息会根据您使用过程中的授权情况单独征求您的同意。</span
        ><span
          >如对本政策内容有任何疑问、意见或建议，您可通过“{{ appName }}”提供的各种联系方式与我们联系。
        </span>
      </p>
      <p><span style="-aw-import:ignore">&#xa0;</span></p>
      <p><span style="font-weight:bold">本隐私政策部分将帮助您了解以下内容：</span></p>
      <p><span>一、我们如何收集和使用您的个人信息</span></p>
      <p><span>二、我们如何使用Cookie和同类技术</span></p>
      <p><span>三、我们如何共享、转让、披露您的个人信息</span></p>
      <p><span>四、我们如何保护您的个人信息</span></p>
      <p><span>五、您如何管理您的个人信息</span></p>
      <p><span>六、我们如何处理未成年人的个人信息</span></p>
      <p><span>七、我们如何存储您的个人信息</span></p>
      <p><span>八、本隐私政策如何更新</span></p>
      <p><span>九、如何联系我们</span></p>
      <p><span style="-aw-import:spaces">&#xa0;</span></p>
      <p><span style="font-weight:bold">一、我们向您收集的个人信息及其用途</span></p>
      <p style="text-indent:21pt">
        <span style="font-weight:bold">个人信息</span
        ><span
          >是指以电子或者其他方式记录的能够单独或者与其他信息结合识别特定自然人身份或者反映特定自然人活动情况的各种信息。</span
        >
      </p>
      <p style="text-indent:24pt">
        <span style="font-weight:bold">个人敏感信息</span
        ><span
          >是指一旦泄露、非法提供或滥用可能危害人身和财产安全，极易导致个人名誉、身心健康受到损害或歧视性待遇等的个人信息。您知悉并理解我们向您提供的部分服务需要处理您的敏感个人信息，我们将在本隐私权政策中</span
        ><span style="font-weight:bold">对具体个人敏感信息以粗体进行显著标识</span
        ><span
          >。我们仅会基于您的同意，为您提供您需要的服务或出于履行法定义务的需要处理您的敏感个人信息。拒绝这些信息仅会让您无法使用特定功能，但不会影响您使用我们的基本功能。</span
        >
      </p>
      <p style="text-indent:21pt"><span>我们将以下述目的，收集和使用您的个人信息：</span></p>
      <p class="ListParagraph">
        <span>（一）</span
        ><span style="font-weight:normal"
          >当您注册{{ appName }}服务时，您可以通过手机号创建账号，我们需要收集您的</span
        ><span class="fontBold">手机号码、昵称、性别、生日</span
        ><span style="font-weight:normal"
          >，用于为您创建“{{ appName }}”的账号并为您提供相关服务；您也可以使用第三方账号微信进行注册，我们会收集您在</span
        ><span class="fontBold">微信的注册账号相关信息（头像、昵称及您授权的其他信息）及手机号码</span
        ><span style="font-weight:normal"
          >（用来绑定账号），用于为您创建“{{ appName }}”的账号并为您提供相关服务。</span
        >
      </p>
      <p class="ListParagraph">
        <span>（二）</span
        ><span style="font-weight:normal">我们会收集您选择上传的或自主自愿拍摄的</span
        ><span class="fontBold">头像照片</span
        ><span style="font-weight:normal"
          >，用于为您创建“{{ appName }}”的账号头像且不保留面部数据。上传或者拍摄头像照片需要您相应的开启</span
        ><span class="fontBold">相册、相机权限</span
        ><span style="font-weight:normal"
          >来完成照片选择或者拍摄。在注册与使用服务过程中，如果您提供以下额外信息补全个人资料，将有助于我们给您提供更好的服务和体验：</span
        ><span class="fontBold"
          >身高、体重、城市、个性签名、个性标签、年龄、星座、职业、收入情况、家乡、婚姻状况、您本人的真实头像、择偶条件、录制语音、交友心声。</span
        ><span style="font-weight:normal">录制语音需要您相应的开启</span><span class="fontBold">麦克风权限</span
        ><span style="font-weight:normal">来完成语音录制服务</span
        ><ins
          style="-aw-revision-author:'gxp'; -aw-revision-datetime:'2024-05-15T18:39:00'"
          ><span style="font-weight:normal">，</span></ins
        ><ins
          style="-aw-revision-author:'gxp'; -aw-revision-datetime:'2024-05-15T18:44:00'"
          ><span style="font-weight:normal">展示真实定位</span></ins
        ><ins
          style="-aw-revision-author:'gxp'; -aw-revision-datetime:'2024-05-15T18:41:00'"
          ><span style="font-weight:normal">信息需要您</span></ins
        ><ins
          style="-aw-revision-author:'gxp'; -aw-revision-datetime:'2024-05-16T15:17:00'"
          ><span style="font-weight:normal">相应的</span></ins
        ><ins
          style="-aw-revision-author:'gxp'; -aw-revision-datetime:'2024-05-15T18:41:00'"
          ><span style="font-weight:normal">开启</span></ins
        ><ins
          style="-aw-revision-author:'gxp'; -aw-revision-datetime:'2024-05-15T18:41:00'"
          ><span  class="fontBold">地理位置权限</span></ins
        ><ins
          style="-aw-revision-author:'gxp'; -aw-revision-datetime:'2024-05-15T18:40:00'"
          ><span style="font-weight:normal">。</span></ins
        ><del
          style="-aw-revision-author:'gxp'; -aw-revision-datetime:'2024-05-15T18:39:00'"
          ><span style="font-weight:normal">。</span></del
        ><span style="font-weight:normal"
          >但如果您不提供这些信息，将不会影响使用“{{ appName }}”产品或服务的基本功能。</span
        >
      </p>
      <p class="ListParagraph">
        <span style="font-weight:normal"
          >（三）当您浏览查看附近用户以及附近交友房间时，我们会在单独获得您授权同意的情况下获取您的</span
        ><span class="fontBold">地理位置权限</span><span style="font-weight:normal">，记录您的</span
        ><span class="fontBold">地理位置信息</span><span style="font-weight:normal">。此外，</span
        ><span class="fontBold">地理位置信息</span
        ><span style="font-weight:normal"
          >还便于我们用于向其他用户展示您的居住城市及/或为您匹配同城用户及/或为您提供同城用户动态服务。该信息属于敏感信息，拒绝提供该信息会使您无法使用上述功能，但不影响您正常使用{{ appName }}的其他功能，您也可以随时关闭相关权限。</span
        >
      </p>
      <p class="ListParagraph">
        <span style="font-weight:normal">（四）当您使用动态、视频/语音速配、创建家族</span
        ><ins
          style="-aw-revision-author:'gxp'; -aw-revision-datetime:'2024-05-15T18:28:00'"
          ><span style="font-weight:normal">/房间</span></ins
        ><span style="font-weight:normal">、家族群聊、</span
        ><ins
          style="-aw-revision-author:'gxp'; -aw-revision-datetime:'2024-05-15T17:53:00'"
          ><span style="font-weight:normal">进入房间进行</span></ins
        ><span style="font-weight:normal">视频</span
        ><ins
          style="-aw-revision-author:'gxp'; -aw-revision-datetime:'2024-05-15T17:53:00'"
          ><span style="font-weight:normal">或语音</span></ins
        ><span style="font-weight:normal"
          >聊天以及进行红娘/月老资格认证或进行美颜设置时，我们需要您相应的开启</span
        ><span class="fontBold">相册、相机、麦克风权限</span
        ><span style="font-weight:normal"
          >来完成拍摄照片、视频或者语音交互。如涉及到位置服务，您还需要相应的开启</span
        ><span class="fontBold">地理位置权限</span><span style="font-weight:normal">。</span
        ><del
          style="-aw-revision-author:'gxp'; -aw-revision-datetime:'2024-05-11T18:36:00'"
          ><span style="font-weight:normal">此外，当您使用</span></del
        ><del
          style="-aw-revision-author:'gxp'; -aw-revision-datetime:'2024-05-11T18:36:00'"
          ><span style="font-weight:normal">申请成为红娘/月老</span></del
        ><del
          style="-aw-revision-author:'gxp'; -aw-revision-datetime:'2024-05-11T18:36:00'"
          ><span style="font-weight:normal">、创建家族或</span></del
        ><del
          style="-aw-revision-author:'gxp'; -aw-revision-datetime:'2024-05-11T18:36:00'"
          ><span style="font-weight:normal">按照国家法律规定</span></del
        ><del
          style="-aw-revision-author:'gxp'; -aw-revision-datetime:'2024-05-11T18:36:00'"
          ><span style="font-weight:normal">或其他需要进行实名认证的服务时，</span></del
        ><del
          style="-aw-revision-author:'gxp'; -aw-revision-datetime:'2024-05-11T18:36:00'"
          ><span style="font-weight:normal">我们</span></del
        ><del
          style="-aw-revision-author:'gxp'; -aw-revision-datetime:'2024-05-11T18:36:00'"
          ><span style="font-weight:normal">还需要</span></del
        ><del
          style="-aw-revision-author:'gxp'; -aw-revision-datetime:'2024-05-11T18:36:00'"
          ><span style="font-weight:normal">收集您的</span></del
        ><del
          style="-aw-revision-author:'gxp'; -aw-revision-datetime:'2024-05-11T18:36:00'"
          ><span>身份信息（真实姓名</span></del
        ><del
          style="-aw-revision-author:'gxp'; -aw-revision-datetime:'2024-05-11T18:36:00'"
          ><span>、</span></del
        ><del
          style="-aw-revision-author:'gxp'; -aw-revision-datetime:'2024-05-11T18:36:00'"
          ><span>身份证号</span></del
        ><del
          style="-aw-revision-author:'gxp'; -aw-revision-datetime:'2024-05-11T18:36:00'"
          ><span>、生物识别特征</span></del
        ><del
          style="-aw-revision-author:'gxp'; -aw-revision-datetime:'2024-05-11T18:36:00'"
          ><span>）</span></del
        ><del
          style="-aw-revision-author:'gxp'; -aw-revision-datetime:'2024-05-11T18:36:00'"
          ><span style="font-weight:normal">，用于为您完成实名认证。</span></del
        ><span style="font-weight:normal"
          >如您不使用我们提供的上述服务，则我们不会访问您的手机相机，您也可以随时取消对我们访问您的手机相机的授权。</span
        >
      </p>
      <p class="ListParagraph">
        <span style="font-weight:normal"
          >（五）当您选择与您感兴趣的人建立关注关系、通过我们提供的功能组件向其他第三方分享信息时，我们会收集包括您的</span
        ><span class="fontBold">关注关系、分享历史在内的服务日志信息</span
        ><span style="font-weight:normal">用于实现上述功能及其他我们明确告知的目的。</span>
      </p>
      <p class="ListParagraph">
        <span style="font-weight:normal">（六）</span
        ><del
          style="-aw-revision-author:'gxp'; -aw-revision-datetime:'2024-05-11T19:06:00'"
          ><span style="font-weight:normal">我们会收集您</span></del
        ><ins
          style="-aw-revision-author:'gxp'; -aw-revision-datetime:'2024-05-11T19:06:00'"
          ><span style="font-weight:normal"
            >当您使用充值、提现相关功能时，充值服务会由我们关联的第三方支付机构向您提供，第三方支付机构会根据功能或服务在最小必要范围内收集您的支付账号信息；收益提现服务会收集您的</span
          ></ins
        ><ins
          style="-aw-revision-author:'gxp'; -aw-revision-datetime:'2024-05-11T19:06:00'"
          ><span  class="fontBold">支付宝账号信息（手机号、邮箱）</span></ins
        ><ins
          style="-aw-revision-author:'gxp'; -aw-revision-datetime:'2024-05-11T19:06:00'"
          ><span style="font-weight:normal"
            >，拒绝提供以上信息将导致您无法使用相关功能，但不影响您使用其他功能。</span
          ></ins
        ><del
          style="-aw-revision-author:'gxp'; -aw-revision-datetime:'2024-05-11T19:06:00'"
          ><span style="font-weight:normal">提供的</span></del
        ><del
          style="-aw-revision-author:'gxp'; -aw-revision-datetime:'2024-05-11T19:06:00'"
          ><span>微信支付信息、支付宝支付</span></del
        ><del
          style="-aw-revision-author:'gxp'; -aw-revision-datetime:'2024-05-11T19:06:00'"
          ><span>信息</span></del
        ><del
          style="-aw-revision-author:'gxp'; -aw-revision-datetime:'2024-05-11T19:06:00'"
          ><span>、苹果支付信息</span></del
        ><del
          style="-aw-revision-author:'gxp'; -aw-revision-datetime:'2024-05-11T19:06:00'"
          ><span style="font-weight:normal">，用于为您提供购买平台</span></del
        ><del
          style="-aw-revision-author:'gxp'; -aw-revision-datetime:'2024-05-11T19:06:00'"
          ><span>虚拟货币</span></del
        ><del
          style="-aw-revision-author:'gxp'; -aw-revision-datetime:'2024-05-11T19:06:00'"
          ><span style="font-weight:normal">—爱心的服务。</span></del
        >
      </p>
      <p class="ListParagraph">
        <span style="font-weight:normal">（七）当您</span
        ><ins
          style="-aw-revision-author:'gxp'; -aw-revision-datetime:'2024-05-23T11:34:00'"
          ><span style="font-weight:normal"
            >使用红人计划、打招呼、发动态、视频速配、发送消息或其他需要完成真人认证的功能或服务时，我们需要您提供</span
          ></ins
        ><ins
          style="-aw-revision-author:'gxp'; -aw-revision-datetime:'2024-05-23T11:34:00'"
          ><span class="fontBold">人脸信息</span></ins
        ><ins
          style="-aw-revision-author:'gxp'; -aw-revision-datetime:'2024-05-23T11:34:00'"
          ><span style="font-weight:normal">用于完成真人认证；</span></ins
        ><ins
          style="-aw-revision-author:'gxp'; -aw-revision-datetime:'2024-05-23T11:34:00'"
          ><span style="font-weight:normal">当您</span></ins
        ><ins
          style="-aw-revision-author:'gxp'; -aw-revision-datetime:'2024-05-11T19:07:00'"
          ><span style="font-weight:normal"
            >使用申请成为红娘/月老、创建家族、进行收益提现、创建房间、申请找回密码或</span
          ></ins
        ><ins
          style="-aw-revision-author:'gxp'; -aw-revision-datetime:'2024-05-23T11:32:00'"
          ><span style="font-weight:normal"
            >其他根据法律法规要求需要完成实名认证的功能或服务</span
          ></ins
        ><ins
          style="-aw-revision-author:'gxp'; -aw-revision-datetime:'2024-05-11T19:07:00'"
          ><span style="font-weight:normal">时，我们需要您提供</span></ins
        ><ins
          style="-aw-revision-author:'gxp'; -aw-revision-datetime:'2024-05-15T16:30:00'"
          ><span class="fontBold">相关</span></ins
        ><ins
          style="-aw-revision-author:'gxp'; -aw-revision-datetime:'2024-05-11T19:07:00'"
          ><span class="fontBold">认证信息（真实姓名、身份证号</span></ins
        ><ins
          style="-aw-revision-author:'gxp'; -aw-revision-datetime:'2024-05-16T15:23:00'"
          ><span>、</span></ins
        ><ins
          style="-aw-revision-author:'gxp'; -aw-revision-datetime:'2024-05-11T19:07:00'"
          ><span class="fontBold">人脸信息，根据实际情况会有所不同）</span></ins
        ><ins
          style="-aw-revision-author:'gxp'; -aw-revision-datetime:'2024-05-23T11:39:00'"
          ><span style="font-weight:normal">，</span></ins
        ><ins
          style="-aw-revision-author:'gxp'; -aw-revision-datetime:'2024-05-11T19:07:00'"
          ><span style="font-weight:normal"
            >并授权我们通过第三方实名认证服务商进行核验，用于完成</span
          ></ins
        ><ins
          style="-aw-revision-author:'gxp'; -aw-revision-datetime:'2024-05-23T11:35:00'"
          ><span style="font-weight:normal">相关</span></ins
        ><ins
          style="-aw-revision-author:'gxp'; -aw-revision-datetime:'2024-05-11T19:07:00'"
          ><span style="font-weight:normal">认证</span></ins
        ><ins
          style="-aw-revision-author:'gxp'; -aw-revision-datetime:'2024-05-23T11:33:00'"
          ><span style="font-weight:normal">；</span></ins
        ><ins
          style="-aw-revision-author:'gxp'; -aw-revision-datetime:'2024-05-15T16:30:00'"
          ><span style="font-weight:normal">同时进行真人认证需要您先上传本人头像照片，需要您相应的开启相册、相机权限来完成照片选择或拍摄，进行</span></ins
        ><ins
          style="-aw-revision-author:'gxp'; -aw-revision-datetime:'2024-05-15T16:30:00'"
          ><span class="fontBold">人脸信息</span></ins
        ><ins
          style="-aw-revision-author:'gxp'; -aw-revision-datetime:'2024-05-15T16:30:00'"
          ><span style="font-weight:normal">验证还需要您相应的开启</span></ins
        ><ins
          style="-aw-revision-author:'gxp'; -aw-revision-datetime:'2024-05-15T16:30:00'"
          ><span class="fontBold">相机权限</span></ins
        ><ins
          style="-aw-revision-author:'gxp'; -aw-revision-datetime:'2024-05-15T16:30:00'"
          ><span style="font-weight:normal">。</span></ins
        ><ins
          style="-aw-revision-author:'gxp'; -aw-revision-datetime:'2024-05-11T19:07:00'"
          ><span style="font-weight:normal">这些信息仅会用于完成实名认证或</span></ins
        ><ins
          style="-aw-revision-author:'gxp'; -aw-revision-datetime:'2024-05-15T16:30:00'"
          ><span style="font-weight:normal">真人</span></ins
        ><ins
          style="-aw-revision-author:'gxp'; -aw-revision-datetime:'2024-05-15T16:31:00'"
          ><span style="font-weight:normal">认</span></ins
        ><ins
          style="-aw-revision-author:'gxp'; -aw-revision-datetime:'2024-05-11T19:07:00'"
          ><span style="font-weight:normal"
            >证的目的，未经您明示授权不会用作其他目的。您可以自主选择是否进行</span
          ></ins
        ><ins
          style="-aw-revision-author:'gxp'; -aw-revision-datetime:'2024-05-15T16:31:00'"
          ><span style="font-weight:normal">相关</span></ins
        ><ins
          style="-aw-revision-author:'gxp'; -aw-revision-datetime:'2024-05-11T19:07:00'"
          ><span style="font-weight:normal">认证，不进</span></ins
        ><ins
          style="-aw-revision-author:'gxp'; -aw-revision-datetime:'2024-05-15T16:31:00'"
          ><span style="font-weight:normal">行</span></ins
        ><ins
          style="-aw-revision-author:'gxp'; -aw-revision-datetime:'2024-05-11T19:07:00'"
          ><span style="font-weight:normal">认证仅会影响您使用相关需要完成认证</span></ins
        ><ins
          style="-aw-revision-author:'gxp'; -aw-revision-datetime:'2024-05-15T16:31:00'"
          ><span style="font-weight:normal">后</span></ins
        ><ins
          style="-aw-revision-author:'gxp'; -aw-revision-datetime:'2024-05-11T19:07:00'"
          ><span style="font-weight:normal"
            >才能使用的功能或服务，不会影响您使用其他功能或服务。</span
          ></ins
        ><del
          style="-aw-revision-author:'gxp'; -aw-revision-datetime:'2024-05-11T19:07:00'"
          ><span style="font-weight:normal">进行收益提现时，我们会收集您提供的</span></del
        ><del
          style="-aw-revision-author:'gxp'; -aw-revision-datetime:'2024-05-11T19:07:00'"
          ><span>支付宝账号信息以及身份认证信息（真实姓名、身份证号、生物识别特征）</span></del
        ><del
          style="-aw-revision-author:'gxp'; -aw-revision-datetime:'2024-05-11T19:07:00'"
          ><span style="font-weight:normal">。</span></del
        >
      </p>
      <p class="ListParagraph"><span style="font-weight:normal; -aw-import:ignore">&#xa0;</span></p>
      <p class="ListParagraph">
        <span style="font-weight:normal"
          >（八）我们会根据您在安装及使用“{{ appName }}”软件及相关服务的过程中或“{{ appName }}”软件在后台运行时授予的具体权限收集您所使用的</span
        ><span class="fontBold">设备相关信息</span
        ><span
          >（包括设备型号、操作系统版本、设置参数、设备配置、设备标识（IMEI/Android
          ID/OAID/IDFA/IDFV/MEID/UDID/SIM卡IMSI信息/ICCID/VAID/AAID等）、设备序列号、MAC地址、设备网络信息(运营商信息/WIFI信息/SSID/BSSID)、设备环境、SD
          card信息、运行中的进程信息、软件列表等软硬件特征信息）、设备所在位置相关信息<span class="fontBold">（包括您授权的GPS位置以及WLAN接入点、蓝牙和基站等传感器信息）。</span></span
        ><span class="fontBold">服务日志信息：</span
        ><span style="font-weight:normal"
          >当您使用我们的产品或服务时，我们会自动收集您对我们服务的详细使用情况，作为有关服务日志保存。包括您的浏览、点击查看和搜索查询内容、关注分享信息、发布信息，以及IP地址、浏览器的类型、运营商信息、使用的语言、访问日期和时间。用于向您提供更好的展示和搜索结果、了解产品适配性、识别账号异常状态。</span
        ><span style="text-decoration:underline" class="fontBold"
          >请注意，单独的设备信息、日志信息是无法识别特定自然人身份的信息。</span
        ><span style="font-weight:normal"
          >如果我们将这类信息与其他信息结合用于识别特定自然人身份，或者将其与个人信息结合使用，则在结合使用期间，这类信息将被视为个人信息，除取得您授权或法律法规另有规定外，我们会将该类个人信息做匿名化、去标识化处理。</span
        >
      </p>
      <p class="ListParagraph">
        <span style="font-weight:normal">（九）我们可能使用或整合您的</span
        ><span class="fontBold">用户信息、设备信息及有关网络日志</span
        ><span style="font-weight:normal"
          >，为提高您使用我们提供服务的安全性，保护您或其他用户或公众的人身财产安全免遭侵害，更好地预防钓鱼网站、欺诈、网络漏洞、计算机病毒、网络攻击、网络侵入等安全风险，更准确地识别违反法律法规或“{{ appName }}”相关协议规则的情况，并用于综合判断您账户风险、进行账户验证、检测及防范安全事件，并依法采取必要的记录、分析、处置措施。</span
        >
      </p>
      <p class="ListParagraph">
        <span style="font-weight:normal"
          >（十）在您与我们联系或提出争议纠纷处理申请时，为了保障您的账户及系统安全，我们需要您</span
        ><span class="fontBold">提供必要的个人信息以核验您的身份</span
        ><span style="font-weight:normal"
          >。当您联系客服或提交意见反馈上传照片时，您还需要相应的开启</span
        ><span class="fontBold">相机、相册权限</span><span style="font-weight:normal">。我们会保存您的</span
        ><span class="fontBold">通信/通话记录和内容或您留下的联系方式</span
        ><span style="font-weight:normal"
          >和其他信息，以便与您联系或帮助您解决问题，或记录相关问题的处理方案及结果。</span
        >
      </p>
      <p class="ListParagraph">
        <span style="font-weight:normal"
          >（十一）我们在运营过程中可能会通过你在使用产品及/或服务的过程中所提供的联系方式（如</span
        ><span class="fontBold">电话号码</span
        ><span style="font-weight:normal"
          >），向你同时发送一种或多种类型的通知，如消息告知、身份验证、安全验证、用户使用体验调研。如您不愿意接受这些信息，您可以通过手机短信中提供的退订方式进行退订，也可以直接与我们联系进行退订。</span
        >
      </p>
      <p class="ListParagraph">
        <span style="font-weight:normal"
          >（十二）当您使用{{ appName }}服务时，为实现信息分享、参加相关活动等目的所必需，我们需要调用您的</span
        ><span class="fontBold">剪切板</span><span style="font-weight:normal">并使用与功能相关的最小必要信息</span
        ><span class="fontBold">（口令、链接、统计参数）</span
        ><span style="font-weight:normal"
          >。我们仅会在识别出剪切板的内容属于{{ appName }}APP分享或参与活动本身时才会上传到我们的服务器，此外我们不会读取和上传您剪切板中的其他信息。</span
        >
      </p>
      <p class="ListParagraph">
        <span style="font-weight:normal">（十三）我们会收集您的</span
        ><span class="fontBold">传感器信息（陀螺仪、步测器、光线、加速度、磁场、距离、旋转矢量等传感器信息）</span
        ><span style="font-weight:normal"
          >，通过传感器获取设备状态（方向、角度、加速度等）用于拍摄时调整画面角度帮助您使用正确的角度体验产品或者语音时调整声音播放方式（听筒扬声器转换）为您提供更好的适配效果以及保障账号安全，为您提供安全、可信的产品与使用环境。</span
        >
      </p>
      <p class="ListParagraph">
        <span style="font-weight:normal"
          >（十四）为确保应用处于后台或者关闭状态下您可以正常接受来自应用的推送消息，我们需要您开启</span
        ><span class="fontBold">自启动</span
        ><span style="font-weight:normal"
          >来保障您能及时查看。因此会存在通过系统发送广播唤醒{{ appName }}自启动的行为，这是保障消息能及时送达所必需的。您可以在设备设置中进行应用启动管理，但关闭后可能导致您的消息接收延迟。</span
        >
      </p>
      <p class="ListParagraph">
        <span style="font-weight:normal">（十五）我们需要获取您的</span><span class="fontBold">手机通知权限</span
        ><span style="font-weight:normal"
          >，用于我们向您推送相关服务通知，如您不想收到上述通知，您可以随时关闭我们使用您手机通知的权限。</span
        >
      </p>
      <p class="dingdocnormal">
        <span style="font-size:12pt"
          >（十六）为确保{{ appName }}相关业务功能的正常实现，我们需要根据具体的业务场景调用对应的系统权限并在调用前向您弹窗询问。我们会遵循合法、正当、必要的原则，并在获得您的同意后进行调用。拒绝提供权限仅会使您无法使用对应功能，但不影响您正常使用{{ appName }}的其他功能。您可以随时查看权限状态和选择关闭部分或全部权限。在不同的设备中，上述权限的开启和关闭方式可能有所不同，具体可参考设备及系统开发方的说明或指引。</span
        >
      </p>
      <p><span>关于{{ appName }}调用权限的具体情况，详见<b
            @click="goto4Page"
            style="text-decoration: underline;"
            >《设备权限清单》</b>。</span></p>
      <p><span>（十七）征得授权同意的例外</span></p>
      <p style="text-indent:21pt">
        <span>根据相关法律法规规定，以下情形中收集您的个人信息无需征得您的授权同意：</span>
      </p>
      <p style="text-indent:21pt">
        <ins
          style="-aw-revision-author:'gxp'; -aw-revision-datetime:'2024-05-15T16:11:00'"
          ><span>（</span></ins
        ><ins
          style="-aw-revision-author:'gxp'; -aw-revision-datetime:'2024-05-15T16:11:00'"
          ><span>1</span></ins
        ><ins
          style="-aw-revision-author:'gxp'; -aw-revision-datetime:'2024-05-15T16:11:00'"
          ><span
            >）为订立、履行个人作为一方当事人的合同所必需，或者按照依法制定的劳动规章制度和依法签订的集体合同实施人力资源管理所必需；</span
          ></ins
        >
      </p>
      <p style="text-indent:21pt">
        <ins
          style="-aw-revision-author:'gxp'; -aw-revision-datetime:'2024-05-15T16:11:00'"
          ><span>（</span></ins
        ><ins
          style="-aw-revision-author:'gxp'; -aw-revision-datetime:'2024-05-15T16:11:00'"
          ><span>2</span></ins
        ><ins
          style="-aw-revision-author:'gxp'; -aw-revision-datetime:'2024-05-15T16:11:00'"
          ><span>）为履行法定职责或者法定义务所必需；</span></ins
        >
      </p>
      <p style="text-indent:21pt">
        <ins
          style="-aw-revision-author:'gxp'; -aw-revision-datetime:'2024-05-15T16:11:00'"
          ><span>（</span></ins
        ><ins
          style="-aw-revision-author:'gxp'; -aw-revision-datetime:'2024-05-15T16:11:00'"
          ><span>3</span></ins
        ><ins
          style="-aw-revision-author:'gxp'; -aw-revision-datetime:'2024-05-15T16:11:00'"
          ><span
            >）为应对突发公共卫生事件，或者紧急情况下为保护自然人的生命健康和财产安全所必需；</span
          ></ins
        >
      </p>
      <p style="text-indent:21pt">
        <ins
          style="-aw-revision-author:'gxp'; -aw-revision-datetime:'2024-05-15T16:11:00'"
          ><span>（</span></ins
        ><ins
          style="-aw-revision-author:'gxp'; -aw-revision-datetime:'2024-05-15T16:11:00'"
          ><span>4</span></ins
        ><ins
          style="-aw-revision-author:'gxp'; -aw-revision-datetime:'2024-05-15T16:11:00'"
          ><span>）为公共利益实施新闻报道、舆论监督等行为，在合理的范围内处理个人信息；</span></ins
        >
      </p>
      <p style="text-indent:21pt">
        <ins
          style="-aw-revision-author:'gxp'; -aw-revision-datetime:'2024-05-15T16:11:00'"
          ><span>（</span></ins
        ><ins
          style="-aw-revision-author:'gxp'; -aw-revision-datetime:'2024-05-15T16:11:00'"
          ><span>5</span></ins
        ><ins
          style="-aw-revision-author:'gxp'; -aw-revision-datetime:'2024-05-15T16:11:00'"
          ><span
            >）依照本法规定在合理的范围内处理个人自行公开或者其他已经合法公开的个人信息；</span
          ></ins
        >
      </p>
      <p class="ListParagraph" style="margin-left:29.9pt; text-indent:12pt">
        <del
          style="-aw-revision-author:'gxp'; -aw-revision-datetime:'2024-05-15T16:11:00'"
          ><span style="font-weight:normal; color:#000000"
            ><span style="">（1）</span></span
          ></del
        ><span
          style="width:2.43pt; font:7pt 'Times New Roman'; display:inline-block; -aw-import:spaces"
          >&#xa0; </span
        ><ins
          style="-aw-revision-author:'gxp'; -aw-revision-datetime:'2024-05-15T16:11:00'"
          ><span style="font-weight:normal">（</span></ins
        ><ins
          style="-aw-revision-author:'gxp'; -aw-revision-datetime:'2024-05-15T16:11:00'"
          ><span style="font-weight:normal">6</span></ins
        ><ins
          style="-aw-revision-author:'gxp'; -aw-revision-datetime:'2024-05-15T16:11:00'"
          ><span style="font-weight:normal">）法律、行政法规规定的其他情形。</span></ins
        ><del
          style="-aw-revision-author:'gxp'; -aw-revision-datetime:'2024-05-15T16:11:00'"
          ><span style="font-weight:normal">与我们履行法律法规规定的义务相关的；</span></del
        >
      </p>
      <p style="text-indent:21pt">
        <span style="font-weight:bold; text-decoration:underline"
          >如我们停止运营“{{ appName }}”软件及相关服务，我们将立即停止收集您个人信息的活动，将停止运营的通知以逐一送达或公告的形式通知您，并按相关法律法规的规定对所持有的个人信息进行删除或匿名化处理。</span
        >
      </p>
      <p><span style="-aw-import:ignore">&#xa0;</span></p>
      <p>
        <span style="font-weight:bold">二、我们如何使用 Cookie 和同类技术 </span
        ><span style="-aw-import:spaces">&#xa0;</span>
      </p>
      <p style="text-indent:24pt">
        <span
          >当您使用{{ appName }}相关服务时，我们会在您的移动设备上存储名为Cookie的小数据文件。Cookie通常包含标识符、站点名称以及一些号码和字符。借助于Cookie，我们能够收集、标识您访问、使用本产品时的信息。我们承诺，不会将Cookie用于本隐私政策所述目的之外的任何其他用途。我们使用Cookie和同类技术主要为了实现以下功能或服务：</span
        >
      </p>
      <p style="text-indent:24pt">
        <span
          >1、确保产品正常运转，保障产品与服务的安全：我们会设置认证与保障安全性的Cookie，使我们确认您是否安全登录服务，或者是否遇到盗用、欺诈及其他不法行为。同时这些技术还会帮助我们改进服务效率，提升登录和响应速度。</span
        >
      </p>
      <p style="text-indent:24pt">
        <span
          >2、为您获得更轻松的访问体验：使用此类技术可以帮助您省去重复填写个人信息、输入搜索内容的步骤和流程（示例：记录搜索、表单填写）。</span
        >
      </p>
      <p style="text-indent:24pt">
        <span
          >如您不想体验相关功能或服务，您可以通过清除缓存来清除cookie数据，但清除后可能无法使用由我们提供的、依赖于Cookie的服务或相应功能。</span
        >
      </p>
      <p><span style="-aw-import:ignore">&#xa0;</span></p>
      <p><span style="font-weight:bold">三、我们如何共享、转让、披露您的个人信息</span></p>
      <p><span style="font-weight:bold">（一）共享</span></p>
      <p style="text-indent:21pt">
        <span
          >我们不会与“{{ appName }}”服务提供者以外的公司、组织和个人共享您的个人信息，但以下情况除外：
        </span>
      </p>
      <ol type="1" class="awlist1" style="margin:0pt; padding-left:0pt">
        <li
          class="ListParagraph"
          style="margin-left:29.9pt; text-indent:-21pt; font-family:DengXian; font-weight:normal; -aw-list-padding-sml:2.33pt"
        >
          <span
            style="width:2.33pt; font:7pt 'Times New Roman'; display:inline-block; -aw-import:ignore"
            >&#xa0; </span
          ><span style="font-family:宋体"
            >在获取明确同意的情况下共享：获得您的明确同意后，我们会与其他方共享您的个人信息。
          </span>
        </li>
        <li
          class="ListParagraph"
          style="margin-left:29.9pt; text-indent:-21pt; font-family:DengXian; font-weight:normal; -aw-list-padding-sml:2.33pt"
        >
          <span
            style="width:2.33pt; font:7pt 'Times New Roman'; display:inline-block; -aw-import:ignore"
            >&#xa0; </span
          ><span style="font-family:宋体"
            >在法定情形下的共享：我们可能会根据法律法规规定、诉讼争议解决需要，或按行政、司法机关依法提出的要求，对外共享您的个人信息。</span
          >
        </li>
        <li
          class="ListParagraph"
          style="margin-left:29.9pt; text-indent:-21pt; font-family:DengXian; font-weight:normal; -aw-list-padding-sml:2.33pt"
        >
          <span
            style="width:2.33pt; font:7pt 'Times New Roman'; display:inline-block; -aw-import:ignore"
            >&#xa0; </span
          ><span style="font-family:宋体"
            >与我们的关联方的必要共享。为向您提供一致化服务，我们可能会将您的个人信息与我们的关联版本共享。但我们只会共享必要的个人信息，并与本政策所声明的目的保持一致。具体共享您信息的类型、使用目的、共享第三方信息可查阅<b
            @click="gotoPage"
            style="text-decoration: underline;"
            >《授权协议》</b
          >。</span
          >
        </li>
        <li
          class="ListParagraph"
          style="margin-left:29.9pt; text-indent:-21pt; font-family:DengXian; font-weight:normal; -aw-list-padding-sml:2.33pt"
        >
          <span
            style="width:2.33pt; font:7pt 'Times New Roman'; display:inline-block; -aw-import:ignore"
            >&#xa0; </span
          ><span style="font-family:宋体"
            >为了使您能够使用相关产品服务及功能，我们的应用中会接入第三方SDK：<b
            @click="goto3Page"
            style="text-decoration: underline;"
            >《第三方SDK共享个人信息清单》</b
          >。</span
          >
        </li>
      </ol>
      <p>
        <span style="-aw-import:spaces">&#xa0;</span
        ><span style="-aw-import:spaces">&#xa0;&#xa0; </span
        ><span
          >我们会对授权合作伙伴获取有关信息的应用程序接口（API）、软件工具开发包（SDK）进行严格的安全检测，并与授权合作伙伴约定严格的数据保护措施，令其按照我们的委托目的、服务说明、本隐私权政策以及其他任何相关的保密和安全措施来处理个人信息。
        </span>
      </p>
      <p><span style="-aw-import:ignore">&#xa0;</span></p>
      <p><span>（二）</span><span style="font-weight:bold">转让</span></p>
      <p style="text-indent:21pt">
        <span>我们不会将您的个人信息转让给任何公司、组织和个人，但以下情况除外：</span
        ><span style="-aw-import:spaces">&#xa0; </span>
      </p>
      <ol type="1" class="awlist2" style="margin:0pt; padding-left:0pt">
        <li
          class="ListParagraph"
          style="margin-left:8.9pt; text-indent:0pt; font-weight:normal; list-style-position:inside; -aw-list-padding-sml:14.43pt"
        >
          <span
            style="width:14.43pt; font:7pt 'Times New Roman'; display:inline-block; -aw-import:ignore"
            >&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0; </span
          ><span
            >在获取明确同意的情况下转让：获得您的明确同意后，我们会向其他方转让您的个人信息。</span
          >
        </li>
        <li
          class="ListParagraph"
          style="margin-left:8.9pt; text-indent:0pt; font-weight:normal; list-style-position:inside; -aw-list-padding-sml:14.43pt"
        >
          <span
            style="width:14.43pt; font:7pt 'Times New Roman'; display:inline-block; -aw-import:ignore"
            >&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0; </span
          ><span
            >在涉及合并、收购或破产清算情形，或其他涉及合并、收购或破产清算情形时，如涉及到个人信息转让，我们会要求新的持有您个人信息的公司、组织继续受本政策的约束，否则我们将要求该公司、组织和个人重新向您征求授权同意。</span
          >
        </li>
      </ol>
      <p><span>（三）</span><span style="font-weight:bold">披露</span><span> </span></p>
      <p style="text-indent:21pt">
        <span>我们不会向任何第三方披露您的个人信息，但以下情形除外：</span>
      </p>
      <ol type="1" class="awlist3" style="margin:0pt; padding-left:0pt">
        <li
          class="ListParagraph"
          style="margin-left:8.9pt; text-indent:0pt; font-family:DengXian; font-weight:normal; list-style-position:inside; -aw-list-padding-sml:14.43pt"
        >
          <span
            style="width:14.43pt; font:7pt 'Times New Roman'; display:inline-block; -aw-import:ignore"
            >&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0; </span
          ><span style="font-family:宋体"
            >您自主自愿选择披露或另行授权我们披露给第三方时，我们会将您同意或选择披露的个人信息披露给您指定的第三方。</span
          >
        </li>
        <li
          class="ListParagraph"
          style="margin-left:8.9pt; text-indent:0pt; font-family:DengXian; font-weight:normal; list-style-position:inside; -aw-list-padding-sml:14.43pt"
        >
          <span
            style="width:14.43pt; font:7pt 'Times New Roman'; display:inline-block; -aw-import:ignore"
            >&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0; </span
          ><span style="font-family:宋体">我们依据相关法律法规基于下述情形披露您的个人信息：</span>
          <ol type="1" class="awlist4" style="margin-right:0pt; margin-left:0pt; padding-left:0pt">
            <li
              class="ListParagraph"
              style="margin-left:0pt; font-weight:normal; -aw-list-padding-sml:2.43pt"
            >
              <span
                style="width:2.43pt; font:7pt 'Times New Roman'; display:inline-block; -aw-import:ignore"
                >&#xa0; </span
              ><span>与国家安全、国防安全有关的；</span>
            </li>
            <li
              class="ListParagraph"
              style="margin-left:0pt; font-weight:normal; -aw-list-padding-sml:2.43pt"
            >
              <span
                style="width:2.43pt; font:7pt 'Times New Roman'; display:inline-block; -aw-import:ignore"
                >&#xa0; </span
              ><span>与公共安全、公共卫生、重大公共利益有关的；</span>
            </li>
            <li
              class="ListParagraph"
              style="margin-left:0pt; font-weight:normal; -aw-list-padding-sml:2.43pt"
            >
              <span
                style="width:2.43pt; font:7pt 'Times New Roman'; display:inline-block; -aw-import:ignore"
                >&#xa0; </span
              ><span>与犯罪侦查、起诉、审判和判决执行等有关的；</span>
            </li>
            <li
              class="ListParagraph"
              style="margin-left:0pt; font-weight:normal; -aw-list-padding-sml:2.43pt"
            >
              <span
                style="width:2.43pt; font:7pt 'Times New Roman'; display:inline-block; -aw-import:ignore"
                >&#xa0; </span
              ><span>出于维护您或其他个人的生命、财产等重大合法权益但又很难得到本人同意的；</span>
            </li>
            <li
              class="ListParagraph"
              style="margin-left:0pt; font-weight:normal; -aw-list-padding-sml:2.43pt"
            >
              <span
                style="width:2.43pt; font:7pt 'Times New Roman'; display:inline-block; -aw-import:ignore"
                >&#xa0; </span
              ><span
                >从合法公开披露的信息中收集个人信息的，如合法的新闻报道、政府信息公开等渠道；</span
              >
            </li>
            <li
              class="ListParagraph"
              style="margin-left:0pt; font-weight:normal; -aw-list-padding-sml:2.43pt"
            >
              <span
                style="width:2.43pt; font:7pt 'Times New Roman'; display:inline-block; -aw-import:ignore"
                >&#xa0; </span
              ><span>其他法律法规规定或司机机关要求的情形。</span>
            </li>
          </ol>
        </li>
      </ol>
      <p style="text-indent:8.9pt">
        <span>根据《中华人民共和国网络安全法》等相关法律法规的规定，</span
        ><span style="font-weight:bold; text-decoration:underline">共享</span
        ><span style="text-decoration:underline">、</span
        ><span style="font-weight:bold; text-decoration:underline"
          >转让、披露经去标识化处理的个人信息</span
        ><span style="text-decoration:underline">，</span
        ><span style="font-weight:bold; text-decoration:underline"
          >且确保数据接收方无法复原并重新识别个人信息主体的</span
        ><span style="text-decoration:underline">，</span
        ><span style="font-weight:bold; text-decoration:underline"
          >不属于个人信息的对外共享、转让及披露行为</span
        ><span style="text-decoration:underline">，</span
        ><span style="font-weight:bold; text-decoration:underline"
          >对此类数据的保存及处理将不再另行向您通知并征得您的同意</span
        ><span style="text-decoration:underline">。</span>
      </p>
      <p><span style="-aw-import:ignore">&#xa0;</span></p>
      <p><span style="font-weight:bold">四、我们如何保护您的个人信息</span></p>
      <p style="margin-left:8.9pt">
        <span
          >（一）我们努力为用户的个人信息提供安全保障，以防止用户个人信息的非法使用、未经授权的访问和披露、泄漏、损坏和丢失。我们将在合理的安全水平内使用各种安全保护措施以保障信息的安全。</span
        ><del
          style="-aw-revision-author:'gxp'; -aw-revision-datetime:'2024-05-15T16:14:00'"
          ><span>例如，</span></del
        ><span>我们会使用加密技术（</span
        ><del
          style="-aw-revision-author:'gxp'; -aw-revision-datetime:'2024-05-15T16:14:00'"
          ><span>例</span></del
        ><span
          >如SSL）、匿名化处理、加密存储等手段来保护你的个人信息；建立受信赖的保护机制防止个人信息遭到恶意攻击；建立访问控制机制，遵守最小权限原则，确保只有授权人员才可访问个人信息；开展安全和个人信息保护培训课程，加强员工对于保护个人信息保护的认识。</span
        >
      </p>
      <p style="margin-left:8.9pt">
        <span
          >（二）我们有行业先进的以数据为核心，围绕数据生命周期进行的数据安全管理体系，从管理机构、组织建设、制度体系、产品技术等方面多维度提升整个系统的安全性。我们建立专门的管理制度、流程和组织以保障个人信息的安全。</span
        ><del
          style="-aw-revision-author:'gxp'; -aw-revision-datetime:'2024-05-15T16:15:00'"
          ><span>例如，</span></del
        ><span
          >我们严格限制访问信息的人员范围，要求他们遵守保密义务，并进行审计。若发生个人信息泄露等安全事件，我们会启动应急预案，阻止安全事件扩大，并以推送通知、公告等形式告知您。</span
        >
      </p>
      <p style="margin-left:8.9pt">
        <span>（三）我们会采取合理可行的措施，尽力避免收集无关的个人信息。</span>
      </p>
      <p style="margin-left:8.9pt; text-indent:12.1pt">
        <span
          >如您发现自己的个人信息尤其是您的账户或密码发生泄露，请您立即联络我们，以便我们根据您的申请采取相应措施。</span
        >
      </p>
      <p style="margin-left:8.9pt; text-indent:12.1pt">
        <span
          >请注意，您在使用我们服务时自愿共享甚至公开分享的信息，可能会涉及您或他人的个人信息，请您更加谨慎地考虑，是否在使用我们的服务时共享甚至公开分享相关信息。</span
        >
      </p>
      <p style="margin-left:8.9pt; text-indent:12.1pt">
        <span>同时，我们还将按照监管部门要求，上报个人信息安全事件的处置情况。</span>
      </p>
      <p><span style="-aw-import:ignore">&#xa0;</span></p>
      <p><span style="font-weight:bold">五、您如何管理您的个人信息</span></p>
      <p style="text-indent:21pt"><span>您可以通过以下方式访问及管理您的个人信息：</span></p>
      <p style="text-indent:21pt">
        <span style="font-weight:bold">（一）访问</span
        ><ins
          style="-aw-revision-author:'gxp'; -aw-revision-datetime:'2024-05-15T15:44:00'"
          ><span style="font-weight:bold">、复制、转移</span></ins
        ><span style="font-weight:bold">您的个人信息</span>
      </p>
      <p style="text-indent:21pt">
        <span
          >您有权访问您的个人信息，法律法规规定的例外情况除外。您可以通过以下方式自行访问您的个人信息：</span
        >
      </p>
      <p style="text-indent:21pt">
        <span>账户信息—如果您希望访问或编辑您的账户中的个人资料信息</span
        ><ins
          style="-aw-revision-author:'gxp'; -aw-revision-datetime:'2024-05-15T15:51:00'"
          ><span>，</span></ins
        ><del
          style="-aw-revision-author:'gxp'; -aw-revision-datetime:'2024-05-15T15:51:00'"
          ><span>，如</span></del
        ><span>头像</span
        ><ins
          style="-aw-revision-author:'gxp'; -aw-revision-datetime:'2024-05-15T15:51:00'"
          ><span>、</span></ins
        ><del
          style="-aw-revision-author:'gxp'; -aw-revision-datetime:'2024-05-15T15:51:00'"
          ><span>和</span></del
        ><span>昵称</span
        ><ins
          style="-aw-revision-author:'gxp'; -aw-revision-datetime:'2024-05-15T15:51:00'"
          ><span>、生日、身高、体重、居住地、家乡、职业、</span></ins
        ><ins
          style="-aw-revision-author:'gxp'; -aw-revision-datetime:'2024-05-15T15:52:00'"
          ><span style="font-weight: bolder;">月收入、婚姻状态</span>、标签、择偶条件、录制语音和交友心声</ins
        ><span>，您可以</span
        ><del
          style="-aw-revision-author:'gxp'; -aw-revision-datetime:'2024-05-15T15:58:00'"
          ><span>通过</span></del
        ><span>通过点击“我的-编辑资料”来执行此类操作。</span>
      </p>
      <p style="text-indent:21pt">
        <span>如果您无法通过上述路径访问该等个人信息，您可以随时通过“</span
        ><ins
          style="-aw-revision-author:'gxp'; -aw-revision-datetime:'2024-05-15T15:59:00'"
          ><span>我的-联系客服</span></ins
        ><del
          style="-aw-revision-author:'gxp'; -aw-revision-datetime:'2024-05-15T15:59:00'"
          ><span>{{ appName }}</span></del
        ><span>”</span
        ><del
          style="-aw-revision-author:'gxp'; -aw-revision-datetime:'2024-05-15T15:59:00'"
          ><span>客服</span></del
        ><span>与我们取得联系。我们将在15天内回复您的访问请求。</span>
      </p>
      <p style="text-indent:21pt">
        <ins
          style="-aw-revision-author:'gxp'; -aw-revision-datetime:'2024-05-15T16:00:00'"
          ><span>复制和转移您的个人信息。</span></ins
        ><ins
          style="-aw-revision-author:'gxp'; -aw-revision-datetime:'2024-05-15T16:01:00'"
          ><span
            >您可以通过点击“我的-联系客服”与我们联系，我们会在核实您的诉求和身份后，向您或您指定的第三方接收方提供您的个人信息副本。</span
          ></ins
        >
      </p>
      <p style="text-indent:21pt">
        <span
          >对于您在使用我们的产品或服务过程中产生的其他个人信息，我们将根据本条“（六）响应您的上述请求”中的相关安排向您提供。
        </span>
      </p>
      <p style="text-indent:21pt">
        <span style="font-weight:bold">（二）更正或补充您的个人信息</span>
      </p>
      <p style="text-indent:21pt">
        <span
          >当您发现我们处理的关于您的个人信息有错误时，您有权要求我们做出更正或补充。您可以通过本条“（一）访问您的个人信息”中列明的方式提出更正或补充申请。</span
        >
      </p>
      <p style="text-indent:21pt"><span style="font-weight:bold">（三）删除您的个人信息</span></p>
      <p style="text-indent:21pt">
        <span>您可以通过本条“（一）访问您的个人信息”中列明的方式删除您的部分个人信息。</span>
      </p>
      <p style="text-indent:21pt">
        <span>在以下情形中，您可以向我们提出删除个人信息的请求：</span>
      </p>
      <p style="text-indent:21pt"><span>1、如果我们处理个人信息的行为违反法律法规；</span></p>
      <p style="text-indent:21pt">
        <span>2、如果我们收集、使用您的个人信息，却未征得您的明确同意；</span>
      </p>
      <p style="text-indent:21pt">
        <span>3、如果我们处理个人信息的行为严重违反了与您的约定；</span>
      </p>
      <p class="ListParagraph">
        <span style="font-weight:normal"
          >4、如果您不再使用我们的产品或服务，或您主动注销了账号；</span
        >
      </p>
      <p class="ListParagraph">
        <span style="font-weight:normal">5、如果我们永久不再为您提供产品或服务。</span>
      </p>
      <p style="text-indent:21pt"><span>若我们决定响应您的删除请求，我们会及时删除。</span></p>
      <p style="text-indent:21pt">
        <span style="font-weight:bold">当您从我们的服务中删除信息后</span><span>，</span
        ><span style="font-weight:bold">我们可能不会立即从备份系统中删除相应的信息</span
        ><span>，</span><span style="font-weight:bold">但会在备份更新时删除这些信息</span
        ><span>。</span>
      </p>
      <p style="text-indent:21pt">
        <span style="font-weight:bold">（四）改变您授权同意的范围</span>
      </p>
      <p style="text-indent:21pt">
        <span
          >每个业务功能需要一些基本的个人信息才能得以完成（见本隐私政策“第一条”）。除此之外，对于额外个人信息的收集和使用，您可以在设置或与“{{ appName }}”客服联系给予或收回您的授权同意。</span
        >
      </p>
      <p style="text-indent:26.25pt">
        <span>当您收回同意后，我们将不再使用相应的个人信息。</span
        ><span style="font-weight:bold"
          >但您收回同意的决定，不会影响此前基于您的授权而开展的个人信息处理。
        </span>
      </p>
      <p style="text-indent:21pt">
        <span style="font-weight:bold">（五）个人信息主体注销账户</span>
      </p>
      <p style="text-indent:21pt">
        <span>您可以自行在“我的”-“设置”-“账号与安全”-“账户注销(慎用)”页面提交账户注销申请。</span>
      </p>
      <p style="text-indent:21pt">
        <span
          >我们按本政策收集的您的个人信息，将在您注销后立即删除或按相关法律法规的规定进行匿名化处理，但按相关法律法规或司法机关的要求需要延长保存时间的除外。在延长保存期间内，我们会以加密形式安全地存储您的个人信息并进行隔离，直至按相关法律法规或司法机关的要求可以删除或匿名化处理。
        </span>
      </p>
      <p style="text-indent:21pt"><span style="font-weight:bold">（六）响应您的上述请求</span></p>
      <p style="text-indent:21pt">
        <span
          >为保障安全，您可能需要提供书面请求，或以其他方式证明您的身份。我们可能会先要求您验证自己的身份，然后再处理您的请求。</span
        >
      </p>
      <p style="text-indent:21pt">
        <span>我们将在15天内做出答复。如您不满意，还可以通过“{{ appName }}”客服发起投诉。</span>
      </p>
      <p style="text-indent:21pt">
        <span
          >对于您合理的请求，我们原则上不收取费用，但对多次重复、超出合理限度的请求，我们将视情收取一定成本费用。对于那些无端重复、需要过多技术手段</span
        ><ins
          style="-aw-revision-author:'gxp'; -aw-revision-datetime:'2024-05-15T16:18:00'"
          ><span>，</span></ins
        ><del
          style="-aw-revision-author:'gxp'; -aw-revision-datetime:'2024-05-15T16:17:00'"
          ><span>（例如，</span></del
        ><span>需要开发新系统或从根本上改变现行惯例</span
        ><del
          style="-aw-revision-author:'gxp'; -aw-revision-datetime:'2024-05-15T16:18:00'"
          ><span>）</span></del
        ><span>、给他人合法权益带来风险或者非常不切实际的请求，我们可能会予以拒绝。</span>
      </p>
      <p style="text-indent:21pt">
        <span>在以下情形中，按照法律法规要求，我们将无法同意您的请求：</span>
      </p>
      <ol type="1" class="awlist5" style="margin:0pt; padding-left:0pt">
        <li
          class="ListParagraph"
          style="margin-left:29.9pt; text-indent:-21pt; font-weight:normal; -aw-list-padding-sml:2.33pt"
        >
          <span
            style="width:2.33pt; font:7pt 'Times New Roman'; display:inline-block; -aw-import:ignore"
            >&#xa0; </span
          ><span>与国家安全、国防安全有关的；</span>
        </li>
        <li
          class="ListParagraph"
          style="margin-left:29.9pt; text-indent:-21pt; font-weight:normal; -aw-list-padding-sml:2.33pt"
        >
          <span
            style="width:2.33pt; font:7pt 'Times New Roman'; display:inline-block; -aw-import:ignore"
            >&#xa0; </span
          ><span>与公共安全、公共卫生、重大公共利益有关的；</span>
        </li>
        <li
          class="ListParagraph"
          style="margin-left:29.9pt; text-indent:-21pt; font-weight:normal; -aw-list-padding-sml:2.33pt"
        >
          <span
            style="width:2.33pt; font:7pt 'Times New Roman'; display:inline-block; -aw-import:ignore"
            >&#xa0; </span
          ><span>与犯罪侦查、起诉、审判和执行判决等有关的；</span>
        </li>
        <li
          class="ListParagraph"
          style="margin-left:29.9pt; text-indent:-21pt; font-weight:normal; -aw-list-padding-sml:2.33pt"
        >
          <span
            style="width:2.33pt; font:7pt 'Times New Roman'; display:inline-block; -aw-import:ignore"
            >&#xa0; </span
          ><span>有充分证据表明个人信息主体存在主观恶意或滥用权利的；</span>
        </li>
        <li
          class="ListParagraph"
          style="margin-left:29.9pt; text-indent:-21pt; font-weight:normal; -aw-list-padding-sml:2.33pt"
        >
          <span
            style="width:2.33pt; font:7pt 'Times New Roman'; display:inline-block; -aw-import:ignore"
            >&#xa0; </span
          ><span>响应您的请求将导致您或其他个人、组织的合法权益受到严重损害的；</span>
        </li>
        <li
          class="ListParagraph"
          style="margin-left:29.9pt; text-indent:-21pt; font-weight:normal; -aw-list-padding-sml:2.33pt"
        >
          <span
            style="width:2.33pt; font:7pt 'Times New Roman'; display:inline-block; -aw-import:ignore"
            >&#xa0; </span
          ><span>涉及商业秘密的。</span>
        </li>
      </ol>
      <p><span style="-aw-import:ignore">&#xa0;</span></p>
      <p><span style="font-weight:bold">六、我们如何处理未成年人的个人信息</span></p>
      <p style="text-indent:21pt">
        <span>任何18岁以下的未成年人均不得创建自己的用户账户及/或使用我们的服务。</span
        ><span style="-aw-import:spaces">&#xa0; </span>
      </p>
      <p style="text-indent:24pt">
        <span style="font-weight:bold; text-decoration:underline"
          >您理解并承诺，您向我们提供的注册信息是真实的，如果通过未成年保护相关机制识别出您的账号具有未成年使用风险，我们将为您提供青少年保护服务模式。如您认为自己不是未成年人，请您申诉进行实名认证，认证通过后，我们将您的账号立即恢复至原使用状态。</span
        >
      </p>
      <p><span style="-aw-import:ignore">&#xa0;</span></p>
      <p><span style="font-weight:bold">七、我们如何存储您的个人信息</span></p>
      <p style="text-indent:24pt">
        <span
          >我们依照法律法规的规定，将在中华人民共和国境内运营中收集和产生的个人信息，以加密的方式存储在中国境内。</span
        >
      </p>
      <p style="text-indent:21pt">
        <span
          >我们承诺按本政策收集的您的个人信息，仅在为实现目的所必需的时间及法律法规所规定的保存期限内进行保留。在您主动删除个人信息、注销账号或信息超出必要的保存期限后，我们将对您的个人信息进行删除或匿名化处理，按相关法律法规或司法机关的要求需要延长保存时间的除外。在延长保存期间内，我们会以加密形式安全地存储您的个人信息并进行隔离，直至按相关法律法规或司法机关的要求可以删除或匿名化处理。</span
        >
      </p>
      <p style="text-indent:24pt">
        <span
          >当我们的产品或服务发生停止运营的情形时，我们将以推送通知、公告等形式通知您，并在合理的期限内删除您的个人信息或进行匿名化处理。</span
        >
      </p>
      <p><span style="font-weight:bold">八、本隐私政策如何更新</span></p>
      <p style="text-indent:21pt"><span>我们的隐私政策可能变更。</span></p>
      <p style="text-indent:21pt">
        <span
          >未经您明确同意，我们不会限制您按照本隐私政策所应享有的权利。对于重大变更，我们会提供显著的通知（包括我们会通过“{{ appName }}”公示的方式进行通知甚至向您提供弹窗提示）。</span
        >
      </p>
      <p style="text-indent:21pt"><span>本政策所指的重大变更包括但不限于：</span></p>
      <ol type="1" class="awlist6" style="margin:0pt; padding-left:0pt">
        <li
          class="ListParagraph"
          style="margin-left:29.9pt; text-indent:-21pt; font-weight:normal; -aw-list-padding-sml:2.33pt"
        >
          <span
            style="width:2.33pt; font:7pt 'Times New Roman'; display:inline-block; -aw-import:ignore"
            >&#xa0; </span
          ><span
            >我们的服务模式发生重大变化。如处理个人信息的目的、处理的个人信息类型、个人信息的使用方式等；</span
          >
        </li>
        <li
          class="ListParagraph"
          style="margin-left:29.9pt; text-indent:-21pt; font-weight:normal; -aw-list-padding-sml:2.33pt"
        >
          <span
            style="width:2.33pt; font:7pt 'Times New Roman'; display:inline-block; -aw-import:ignore"
            >&#xa0; </span
          ><span>我们在控制权等方面发生重大变化。如并购重组等引起的所有者变更等；</span>
        </li>
        <li
          class="ListParagraph"
          style="margin-left:29.9pt; text-indent:-21pt; font-weight:normal; -aw-list-padding-sml:2.33pt"
        >
          <span
            style="width:2.33pt; font:7pt 'Times New Roman'; display:inline-block; -aw-import:ignore"
            >&#xa0; </span
          ><span>个人信息共享、转让或公开披露的主要对象发生变化；</span>
        </li>
        <li
          class="ListParagraph"
          style="margin-left:29.9pt; text-indent:-21pt; font-weight:normal; -aw-list-padding-sml:2.33pt"
        >
          <span
            style="width:2.33pt; font:7pt 'Times New Roman'; display:inline-block; -aw-import:ignore"
            >&#xa0; </span
          ><span>您参与个人信息处理方面的权利及其行使方式发生重大变化；</span>
        </li>
        <li
          class="ListParagraph"
          style="margin-left:29.9pt; text-indent:-21pt; font-weight:normal; -aw-list-padding-sml:2.33pt"
        >
          <span
            style="width:2.33pt; font:7pt 'Times New Roman'; display:inline-block; -aw-import:ignore"
            >&#xa0; </span
          ><span>我们负责处理个人信息安全的责任部门、联络方式及投诉渠道发生变化时；</span>
        </li>
        <li
          class="ListParagraph"
          style="margin-left:29.9pt; text-indent:-21pt; font-weight:normal; -aw-list-padding-sml:2.33pt"
        >
          <span
            style="width:2.33pt; font:7pt 'Times New Roman'; display:inline-block; -aw-import:ignore"
            >&#xa0; </span
          ><span>个人信息安全影响评估报告表明存在高风险时。</span>
        </li>
      </ol>
      <p style="text-indent:21pt"><span>我们还会将本隐私权政策的旧版本存档，供您查阅。 </span></p>
      <p><span style="-aw-import:ignore">&#xa0;</span></p>
      <p><span style="font-weight:bold">九、如何联系我们</span></p>
      <p style="margin-left:12pt">
        <span>1、您可以通过“{{ appName }}”客服与我们联系，我们将在15天内回复您的请求。</span>
      </p>
      <p style="margin-left:12pt">
        <span>2、如发现个人信息可能被泄露，您可以发邮件至dataprivacy@hellogroup.com投诉举报。</span>
      </p>
      <p style="margin-left:12pt">
        <span
          >3、我们的常用办公地址为北京市朝阳区将台(地区)乡酒仙桥北路甲12号，个人信息保护相关负责人的联系方式为dataprivacy@hellogroup.com。</span
        >
      </p>
      <p><span style="-aw-import:ignore">&#xa0;</span></p>
      <p style="text-indent:12pt">
        <span>如果您对我们的回复不满意，特别是您认为我们的个人信息处理行为损害了您的合法权益，</span
        ><span style="font-weight:bold"
          >您还可以通过向本协议签订地有管辖权的法院提起诉讼来寻求解决方案，本协议签订地为北京市朝阳区。</span
        >
      </p>
    </div>
  </div>
</template>
<style lang="scss">
del {
  display: none;
}
ins {
  text-decoration: none;
}
.fontBold{
    font-weight: bolder
}
.tab1 {
  margin: 0 auto;
  margin-bottom: 20px;
  line-height: 30px;
  color: #9a9eb9;
  text-align: center;
  border-color: #eee;
  tr {
    font-size: 16px;
  }
  .tr1 {
    width: 100px;
  }
  .tr2 {
    min-width: 40px;
  }
  .tr3 {
    width: 80px;
  }
  .tr4 {
    width: 100px;
  }
  .tr5 {
    max-width: 350px;
    word-break: break-all;
  }
}
.thead {
  color: #3f446f;
  font-size: 24px;
  line-height: 30px;
  margin-top: 7px;
  text-align: center;
}
.privacy {
  background-color: #f6f5fb;
}
.privacy-wrapper {
  padding-top: 120px;
  padding: 120px 30px 0 30px;
  width: 690px;
  text-align: left;
}
.privacy-title {
  margin-bottom: 40px;
  font-family: "PingFangSC-Medium";
  font-size: 30px;
  color: rgb(63, 68, 111);
}
.privacy-date {
  margin-left: 300px;
  margin-bottom: 4px;
  text-align: right;
  font-size: 26px;
  width: 390px;
  color: #3f446f;
}
.privacy-date-second {
  margin-bottom: 20px;
}
.privacy-content {
  font-size: 26px;
  color: #3f446f;
  line-height: 41px;
  padding-bottom: 40px;
  .phone {
    text-decoration: underline;
  }
}
</style>
<script>
import HeaderTop from "src/components/HeaderTop.vue";

const { mm } = window;
export default {
  name: "Privacy",
  data() {
    return {
      IOSUser: false,
      appName: this.$store.state.appName
    };
  },
  mounted() {},
  components: {
    "header-top": HeaderTop // 顶部导航组件
  },
  created() {
    console.log("appName:", this.appName);
    const iOS = !!navigator.userAgent.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
    if (iOS) {
      this.IOSUser = iOS;
      // console.log("iOS终端", iOS);
    }
  },
  methods: {
    callServe(phone) {
      mm.ui.openUrl({
        target: 3,
        url: ` goto://MultiFunction_Action_Protocol?action=dail&content=${phone}`
      });
    },
    gotoPage() {
      this.$router.push({
        name: "empower"
      });
    },
    goto3Page() {
      this.$router.push({
        name: "privacyOther"
      });
    },
    goto4Page() {
      this.$router.push({
        name: "privacyQd"
      });
    }
  }
};
</script>
